import React from 'react'

export const LoadingRecordContext = React.createContext<boolean | undefined>(undefined)
